import {NavigateAway} from '@staff-app/actions/contact-info.actions';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {
  LocationActions,
  LocationActionTypes
} from '@staff-app/actions/location.actions';
import {SelectedLocationDTO} from '@staff-app/models/locationDTO';
import {CommonActionTypes, CommonActions} from '@store/actions/common.actions';

export interface State extends EntityState<SelectedLocationDTO> {
  isDataLoadedFromDB: boolean;
  selectedLocationIds: number[];
  willWorkAnywhere: boolean | null;
}

export const adapter: EntityAdapter<SelectedLocationDTO> = createEntityAdapter<
  SelectedLocationDTO
>({
  selectId: (selectedLocation: SelectedLocationDTO) =>
    selectedLocation.location.locationID,
  sortComparer: false
});

export const initialState: State = adapter.getInitialState({
  isDataLoadedFromDB: false,
  selectedLocationIds: null,
  willWorkAnywhere: null
});

export function reducer(
  state = initialState,
  action: LocationActions | CommonActions
): State {
  switch (action.type) {
    case LocationActionTypes.GetAvailableAndSelectedLocations: {

      return  {
        ...state,
        isDataLoadedFromDB: false
      };
    }
    case LocationActionTypes.GetAvailableAndSelectedLocationsSuccessful: {

      return adapter.addMany(action.payload.locations, {
        ...state,
        isDataLoadedFromDB: true,
        willWorkAnywhere: action.payload.willWorkAnywhere,
        selectedLocationIds: state.selectedLocationIds && state.selectedLocationIds.length
                              ? state.selectedLocationIds
                              : action.payload.selectedLocationIDs
      });
    }
    case LocationActionTypes.SaveUserPreferredLocationsSuccessful:
    case LocationActionTypes.NavigateAway:
    case CommonActionTypes.NavigateToSubmitPage: {
      // remove location branch to prevent data load from cache
      return { ...adapter.removeAll(state),
              isDataLoadedFromDB: false,
      };
    }
    case LocationActionTypes.SelectLocations: {
      return {
        ...state,
        selectedLocationIds: action.payload ?? <number[]>[]
      };
    }
    case LocationActionTypes.RemoveSelectedLocation: {
      return {
        ...state,
        selectedLocationIds: state.selectedLocationIds.filter(
          l => l !== action.payload
        ) ?? <number[]>[]
      };
    }
    default: {
      return state;
    }
  }
}

export const isLocationsLoadedFromDB = (state: State) => state.isDataLoadedFromDB;
export const getSelectedLocations = (state: State) => state.selectedLocationIds;
export const getWillWorkAnywhere = (state: State) => state.willWorkAnywhere;
export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();
